import React, { memo } from 'react';
import { Image } from '@tarojs/components';
import { SHEEP_IMAGES } from '@/assets/sheep/individual';

export const hasSheepSprite = (name: string): boolean => !!SHEEP_IMAGES[name];

/** The complete extracted image is fitted directly; no nested atlas clipping. */
const SheepSprite: React.FC<{ name: string; size: number }> = ({ name, size }) => {
  const image = SHEEP_IMAGES[name];
  if (!image) return null;
  const scale = size / Math.max(image.width, image.height);
  return (
    <Image
      data-sprite={name}
      src={image.src}
      mode='aspectFit'
      style={{ display: 'block', flexShrink: 0, width: image.width * scale + 'rpx', height: image.height * scale + 'rpx', pointerEvents: 'none' }}
    />
  );
};
export default memo(SheepSprite);
